import { createAtomObserver } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

const createAssetManagementPlugin = ({
  assetCannotBeDisabledReasonAtom,
  port,
}) => {
  const observer = createAtomObserver({
    atom: assetCannotBeDisabledReasonAtom,
    port,
    event: 'assetCannotBeDisabledReason',
  });

  observer.register();

  return {
    onLoad: () => {
      observer.start();
    },
    onStop: () => {
      observer.unregister();
    },
  };
};

const assetManagementPlugin = {
  id: 'assetManagementPlugin',
  type: 'plugin',
  factory: createAssetManagementPlugin,
  dependencies: ['assetCannotBeDisabledReasonAtom', 'port'],
} as const satisfies Definition;

export default assetManagementPlugin;
